'use strict';

var formValidation = require('../../../../../../app_storefront_base/cartridge/client/default/js/components/formValidation');
var createErrorNotification = require('../../../../../../app_storefront_base/cartridge/client/default/js/components/errorNotification');

module.exports = {
    register: function () {
        $('form.js-wof-form').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            // form.spinner().start(); // If is need a spinner we can activate after client approval
            $('form.js-wof-form').trigger('login:register', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    // form.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);

                        if(data.message) {
                            form.prepend('<div class="alert alert-danger js-login-incorrect-alert">'
                            + data.message + '</div>');
                        }

                        const checkboxError = 'dwfrm_wheelOfFortune_customer_agreedWithTerms';

                        if(data.fields.hasOwnProperty(checkboxError)){

                            const checkboxErrorMessage = data.fields.dwfrm_wheelOfFortune_customer_agreedWithTerms;
                            const errorContainer = $('.js-input-checkbox__container .invalid-feedback');
                            const checkbox = $('.js-input-checkbox__container .input-checkbox');

                            checkbox.addClass('is-invalid')
                            errorContainer.text(checkboxErrorMessage);
                        }
                    } else {
                        if (form.hasClass('js-wof-spinform')) {
                            setTimeout(function () {
                                location.href = data.redirectUrl;
                            }, 2000);
                        } else {
                            location.href = data.redirectUrl;
                        }
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        //window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
                    }

                    // form.spinner().stop();
                }
            });
            return false;
        });
    },
};

